import api from "./ApiClient";

const API_UPLOAD_PATH = '/foodz/api/v1/uploads';

class AssetsService {
  static uploadProductImage(file) {
    const clientCode = sessionStorage.getItem('clientCode');
    return api.post(
      `${API_UPLOAD_PATH}/uploadProduto`,
      file,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { clientCode }
      }
    );
  }

  static uploadStudentProfileImage(file) {
    const clientCode = sessionStorage.getItem('clientCode');
    return api.post(
      `${API_UPLOAD_PATH}/uploadFotoAluno`,
      file,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { clientCode }
      }
    );
  }

  static uploadPaymentReceipt(formData) {
    return api.post(
      `${API_UPLOAD_PATH}/uploadComprovante`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
  }

  static async getProductImage(path) {
    const response = await api.get(
      `${API_UPLOAD_PATH}/carregarImagemDoProduto`,
      { params: { path }, responseType: 'arraybuffer' }
    );

    const base64 = btoa(
      new Uint8Array(response.data)
        .reduce((acc, byte) => acc + String.fromCharCode(byte), '')
    );
    return `data:${response.headers['content-type']};base64,${base64}`;
  }

  static async getProfileImage(path) {
    const response = await api.get(
      `${API_UPLOAD_PATH}/carregarImagemDePerfil`,
      { params: { path }, responseType: 'arraybuffer' }
    );

    const base64 = btoa(
      new Uint8Array(response.data)
        .reduce((acc, byte) => acc + String.fromCharCode(byte), '')
    );
    return `data:${response.headers['content-type']};base64,${base64}`;
  }

  static async getPaymentsReceipt(path) {
    const response = await api.get(
      `${API_UPLOAD_PATH}/carregarComprovante`,
      { params: { path }, responseType: 'blob' }
    );

    const blob = response.data;
    const contentType = response.headers['content-type'] || blob.type;

    let fileName = 'download';
    const cd = response.headers['content-disposition'];
    if (cd) {
      const m = cd.match(/filename="(.+)"/);
      if (m) fileName = m[1];
    }

    const safeBlob = blob.type === contentType
      ? blob
      : new Blob([blob], { type: contentType });

    return {
      url: URL.createObjectURL(safeBlob),
      contentType,
      fileName
    };
  }
}

export default AssetsService;